module.exports = __webpack_public_path__ + "static/media/slr-logo.5a7b016e.png";